import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PRIZES_FEATURE_KEY,
  PrizesState,
  prizesAdapter,
} from './prizes.reducer';

// Lookup the 'Prizes' feature state managed by NgRx
export const getPrizesState =
  createFeatureSelector<PrizesState>(PRIZES_FEATURE_KEY);

const { selectAll, selectEntities } = prizesAdapter.getSelectors();

export const getPrizesLoaded = createSelector(
  getPrizesState,
  (state: PrizesState) => state.loaded,
);

export const getPrizesLoading = createSelector(
  getPrizesState,
  (state: PrizesState) => state.loading,
);

export const getPrizesError = createSelector(
  getPrizesState,
  (state: PrizesState) => state.error,
);

export const getAllPrizes = createSelector(
  getPrizesState,
  (state: PrizesState) => selectAll(state),
);

export const getPrizesEntities = createSelector(
  getPrizesState,
  (state: PrizesState) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getPrizesState,
  (state: PrizesState) => state.selectedId,
);
export const getTotalPrizes = createSelector(
  getPrizesState,
  (state: PrizesState) => state.total,
);
export const getTotalPrizeAmount = createSelector(
  getPrizesState,
  (state: PrizesState) => state.totalPrizeAmount,
);

export const getPrizesWon = createSelector(
  getAllPrizes,
  getTotalPrizes,
  getTotalPrizeAmount,
  (prizes, total, totalPrizeAmount) => {
    return { prizes, total, totalPrizeAmount };
  },
);

export const getSelected = createSelector(
  getPrizesEntities,
  getSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
);
